// @ts-check
import React from 'react'
import { Spinner } from '../Spinner/Spinner'
import cn from 'classnames'
import styles from './style.css'

/**
 * @param {{
 * onClick: {(event: React.MouseEvent): void},
 * disabled: boolean,
 * isLoading: boolean,
 * isInline: boolean,
 * type?: "button" | "submit" | "reset",
 * value?: string | number,
 * children?: React.ReactNode,
 * className: string,
 * style? : "back" | "next",
 * isSmallSpinner?: boolean,
 * id?: string,
 * name: string }} props
 */
const Button = ({
  onClick,
  children,
  disabled,
  isLoading,
  isInline,
  value,
  type,
  className,
  isSmallSpinner,
  style,
  name,
  id
}) => (
  <button
    className={cn(
      styles.button,
      { [styles.inline]: isInline },
      { [styles.back]: style === 'back' && !isLoading },
      { [styles.next]: style === 'next' && !isLoading },
      className)}
    type={type}
    onClick={onClick}
    name={name}
    disabled={disabled}
    id={id}
  >
    {children || value}
    {isLoading && <Spinner isSmall={isSmallSpinner} />}
  </button>
)

Button.defaultProps = {
  onClick: () => {},
  value: '',
  disabled: false,
  isLoading: false,
  isInline: false,
  type: 'button',
  className: '',
  name: 'formSubmit'
}

export { Button }
